export default __webpack_public_path__ + "static/media/dirt-rally.8efd3ff0.png";